import React, { FC, useEffect, useState } from 'react';
import DynamicDropDown from '../@shared/dynamicDropDown';
import { TDropDownOption, TDynamicDropDown, TSelectedDropDownValue } from '../../types/dynamicDropDown.types';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import useDidUpdate from '../../../../hooks/useDidUpdate.effect';
import { APIPrefix } from '../../../../constants/api.constants';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';

const DynamicProductSelector: FC<ValueFieldProps> = (props) => {
    const { field } = props;
    const id = field?.valueField?.id;
    const name = field?.valueField?.name;
    const FieldValidationErrors = props?.fieldValidationErrorsComponent;
    const items = props?.field?.model?.items as TDropDownOption[];
    const isRequired = field?.model?.required;
    const [sendData, setSendData] = useState<TSelectedDropDownValue[]>([{
        itemId: '',
        text: '',
        value: ''
    }]);
    const [value, setValue] = useState('');
    const { sitecoreContext } = useSitecoreContext();
    const siteLanguage = sitecoreContext?.language;

    useEffect(() => {
        if (props?.value?.length === 0 || props?.value === '|' ) {
            setSendData([{
                itemId: '',
                text: '',
                value: ''
            }]);
        }
    }, [props?.value]) 

    const prepareDynamicDropdownStructure = (dropdownItems: TDropDownOption[], hasFurtherDropdowns: boolean): TDynamicDropDown => {
        let furtherDropdowns: any = {
            hasFurtherDropdowns: false
        }
        if (hasFurtherDropdowns) {
            furtherDropdowns = {
                hasFurtherDropdowns: true,
                dropDown: {
                    fields: props,
                    dropdownOptions: [],
                    label: 'cnhi-forms-fields-product-selector-models',
                    isEnabled: false,
                    id: '',
                    furtherDropdowns: {
                        hasFurtherDropdowns: false
                    }
                }
            }
        }
        return {
            fields: props,
            dropdownOptions: dropdownItems,
            label: 'cnhi-forms-fields-product-selector-lines',
            isEnabled: true,
            id,
            furtherDropdowns
        }
    }

    const [dropDown, setDropDown] = useState<TDynamicDropDown>(prepareDynamicDropdownStructure(items, true));

    const fetchData = (itemID: string): void => {
        const getApiURL = `/${APIPrefix}/dynamicproductselector/get-dynamicproduct-list?itemid=${itemID}&language=${siteLanguage}`;
        fetch(getApiURL)
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw Error(`${res.status} : Failed to fetch data`);
                }
            })
            .then((result) => {
                const modelsDropDown: TDynamicDropDown = {
                    fields: props,
                    dropdownOptions: result.dynamicProductList,
                    label: 'cnhi-forms-fields-product-selector-models',
                    isEnabled: true,
                    id: result.itemId,
                    furtherDropdowns: {
                        hasFurtherDropdowns: false
                    }
                }
                setDropDown({...dropDown, furtherDropdowns: {hasFurtherDropdowns: true, dropDown: modelsDropDown}})
            })
            .catch((error) => {
                console.error(`${error} occurred while fetching data`);
            });
    };

    const handleOptionClick = (selectedOptions: TSelectedDropDownValue[]) => {
        if (sendData[0].itemId !== selectedOptions[0].itemId) {
            fetchData(selectedOptions[0].itemId);
        }
        setSendData(selectedOptions); 
    }



    const convertObjectToString = (obj) => {
        const objKeys = Object.keys(obj);
        return objKeys
            .filter((key) => {
                if (key == 'text' || key == 'value') {
                    return key;
                }
            })
            .map((key) => obj[key])
            .join('|');
    };

    const sendProductSelection = sendData.map((obj) => convertObjectToString(obj)).join(',');

    useDidUpdate(() => {
        const hasEmptyLineValues = sendData.some((obj) => obj.text?.trim() === '');

        const sendValue = isRequired && hasEmptyLineValues ? '' : sendProductSelection;

        setValue(sendProductSelection);
        props.onChange(field?.valueField?.name, sendValue, props?.isValid, []);
    }, [sendData]);

    return (
        <div className="sitecore-jss-form__control--dynamic-product-selector">
            <input
                id={id}
                name={name}
                className="sitecore-jss-form__field"
                type="hidden"
                value={`${value}`}
                form="novalidatedform"
            />

            <DynamicDropDown
                dropDown={dropDown}
                handleOptionClick={handleOptionClick}
                sendData={sendData}
            />

            {FieldValidationErrors && <FieldValidationErrors {...props} />}
        </div>
    );
}

export default DynamicProductSelector;
